<template>
    <div class="full-content" style="background-image:url('assets/img/bg-gaspol-1.jpg');">
        <div class="card bg-card-trans border-0 rounded-0 mobile-ver">
            <div class="mobile-ver-top mobile-ver-top-2">
                <div class="d-flex align-items-center h-100 justify-content-between px-3">
                    <div class="d-flex align-items-center">
                        <a href="javascript:void(0)" class="btn btn-white-naked btn-icon me-md-3 me-2" v-on:click="goToPage('dashboard_student')">
                            <i class="fa-solid fa-arrow-left"></i>
                        </a>
                        <div class="d-block display-tektur h1 m-0">Alumni</div>
                    </div>
                </div>
            </div>
            
            <div class="mobile-ver-content--has-simplebar mobile-ver-content-2 full-bottom">
                <div class="d-block px-md-4 px-3 pt-3">
                    <div class="input-icon mb-4 mt-3">
                        <input class="form-control m-0" type="text" placeholder="Cari Alumni disini..." v-model="keywords" v-on:keyup.enter="getData">
                        <i class="fa-solid fa-magnifying-glass text-muted"></i>
                    </div>

                    <div class="row align-items-center mb-3">
                        <div class="col-4">
                            Filter Universitas
                        </div>
                        <div class="col-8">
                            <div class="form-select-wrapper">
                                <v-select
                                    :options="dataUniversity"
                                    label="name"
                                    v-model="filter.university"
                                    placeholder="Semua Universitas"
                                    append-to-body
                                    @input='set_university'
                                    >
                                </v-select>
                            </div>
                        </div>
                    </div>

                    <div class="row align-items-center mb-3">
                        <div class="col-4">
                            Filter Jurusan
                        </div>
                        <div class="col-8">
                            <div class="form-select-wrapper">
                                <v-select
                                    :options="dataMajor"
                                    label="name"
                                    v-model="filter.major"
                                    placeholder="Semua Jurusan"
                                    append-to-body
                                    @input='set_major'
                                    >
                                </v-select>
                            </div>
                        </div>
                    </div>

                    <div class="row align-items-center mb-3">
                        <div class="col-4">
                            Filter Jenjang
                        </div>
                        <div class="col-8">
                            <div class="form-select-wrapper">
                                <i class="fa-solid fa-caret-down"></i>
                                <select class="form-select form-select-box-1" v-model="education_level" v-on:change="getData">
                                    <option value="">Semua Jenjang</option>
                                    <option v-for="(item, index) in dataEducationLevel" :key="index" :value="item">{{ item }}</option>
                                </select>
                            </div>
                        </div>
                    </div>

                    <div v-if="dataFetch" class="d-block mt-4">
                        <div class="card">
                            <div class="card-body">
                                <div class="d-block text-center py-4">
                                    <div class="d-block mb-2 text-muted"><i class="fa-solid fa-spin fa-spinner fa-lg"></i></div>
                                    <div class="d-block text-sm text-muted ">Loading...</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-if="!dataFetch && emptyState" class="d-block mt-4">
                        <div class="card">
                            <div class="card-body">
                                <div class="d-block text-center py-4">
                                    <div class="d-block mb-2 text-pink"><i class="fa-solid fa-triangle-exclamation fa-lg"></i></div>
                                    <div class="d-block text-sm text-muted ">Data tidak ditemukan.</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-if="!dataFetch && dataList.length > 0"  class="d-block">
                        <div class="card mt-4 mb-3" v-for="(item, index) in dataList" :key="index">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-8">
                                        <div class="d-flex align-items-center mb-3">
                                            <div class="box-score">
                                                <span>{{ item.score_passing_grade }}</span>
                                            </div>
                                            <div class="d-block display-tektur ms-2">PM Rapor</div>
                                        </div>
                                        <div class="d-block mb-3">
                                            <div class="d-block">{{ item.major_name }}</div>
                                            <div class="d-block text-sm">{{ item.university_name }}</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="d-flex align-items-center pt-3 border-top overflow-hidden">
                                    <div class="d-block me-3">
                                        <div class="avatar avatar-xs">
                                            <span class="avatar-title rounded-circle bg-white text-dark"><i
                                                    class="fa-solid fa-user fa-lg m-0"></i></span>
                                        </div>
                                    </div>
                                    <div class="d-block text-sm">
                                        <div class="d-block font-bold">{{ item.name }}</div>
                                        <div class="block-ellipsis">{{ item.school_name }}, {{ item.graduation_year }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div aria-label="navigation" class="card-footer d-flex justify-content-between">
                            <!-- Pagination (prev) -->
                            <ul class="list-pagination-prev pagination pagination-tabs card-pagination">
                                <li class="page-item">
                                    <a class="page-link ps-0 pe-4 border-end border-c-1" :class="pagination.current_page <= 1 ? 'disabled':''" href="javascript:void(0)" v-on:click="pagination_handle('prev')">
                                        <i class="fa-solid fa-angle-left me-md-3"></i><span class="hide-767">Sebelumnya</span>
                                    </a>
                                </li>
                            </ul>

                            <v-pagination v-model="pagination.current_page" :page-count="pagination.total_pages" :classes="pagination.style" :labels="pagination.anchor_text" v-on:change="getData()"></v-pagination>

                            <!-- Pagination (next) -->
                            <ul class="list-pagination-next pagination pagination-tabs card-pagination">
                                <li class="page-item">
                                    <a class="page-link ps-4 pe-0 border-start border-c-1" :class="pagination.current_page >= pagination.total_pages ? 'disabled':''" href="javascript:void(0)" v-on:click="pagination_handle('next')">
                                        <span class="hide-767">Selanjutnya</span><i class="fa-solid fa-angle-right ms-md-3"></i>
                                    </a>
                                </li>
                            </ul>
                        </div>

                    </div>
                    
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import vPagination from 'vue-plain-pagination'
export default {
    name: 'StudentMajor',
    metaInfo: {
        title: 'Alumni',
        titleTemplate: '%s - Rasionalisasi Rapor'
    },
    components: {
        vPagination
    },
    data() {
        return {
            filter : {
                university : [],
                major      : []
            },
            emptyState  : false,
            dataFetch   : false,
            dataList    : [],
            keywords    : "",
            group       : "rapor",
            tabActive   : 'tab_rapor',
            pagination: {
                current_page    : 1,
                total_pages     : 0,
                limit           : 5,
                style: {
                    ul: 'list-pagination pagination pagination-tabs card-pagination',
                    li: 'page-item',
                    a: 'page',
                    liActive: 'active',
                    liDisable: 'disabled',
                    button: 'page-link'                
                },
                anchor_text: {
                    first: '',
                    prev: '',
                    next: '',
                    last: ''
                }
            },
            dataUniversity : [],
            university_id : '',
            dataMajor : [],
            major_id : '',
            dataEducationLevel : ['D3','D4','S1'],
            education_level : ''
        }
    },
    created() {
        this.getData();
        this.getUniversity();
        this.getMajor();
    },
    methods: {
        goToPage: function (params = null) {
            this.$router.push({
                name: params
            })
        },
        getData: function() {
            let uri         = process.env.VUE_APP_APIHOST+'passing-grade-alumni/list-for-teacher';

            this.dataFetch  = true;                
            this.$http.get(uri,{
                params : {
                    keywords    : this.keywords,
                    page        : this.pagination.current_page,
                    limit       : this.pagination.limit,
                    tab_active  : this.tabActive,
                    group       : this.group,
                    university_id   : this.university_id,
                    major_id   : this.major_id,
                    education_level : this.education_level
                }
            }).then(res => {
                this.emptyState                 = false;
                this.dataFetch                  = false;                
                this.dataList                   = res.data.data;
                this.pagination.total_pages     = res.data.total_page;

                if(this.dataList.length < 1) {
                    this.emptyState = true;
                }
            });
        },
        pagination_handle: function(params) {
            if(params == 'next') {
                if(this.pagination.current_page < this.pagination.total_pages) {
                    this.pagination.current_page = this.pagination.current_page+1;
                    this.getData();
                }
            }

            if(params == 'prev') {
                if(this.pagination.current_page > 1) {
                    this.pagination.current_page = this.pagination.current_page-1;
                    this.getData();
                }
            }
        },
        deleteData: function (id) {
            this.$swal({
                icon: 'info',
                title: 'Hapus Data',
                text: 'Apakah kamu yakin ingin menghapus data ini?',
                confirmButtonText: 'Hapus',
                showCancelButton: true,
                cancelButtonText: 'Batal',
            }).then((result) => {
            if (result.value) {
                this.$http.post(process.env.VUE_APP_APIHOST + 'passing-grade-major/delete', {
                    id: id
                })
                .then(response => {
                    if (response.data.status) {
                        this.$swal({
                            icon: 'success',
                            title: 'Success',
                            text: response.data.message,
                            confirmButtonText: 'OK'
                        }).then((result) => {
                            if (result.value) {
                                this.getData();
                            }
                        });
                    } else {
                    this.$swal({
                        icon: 'warning',
                        title: 'Ups!',
                        text: response.data.message,
                    });
                    }
                })
            }
            });
        },
        getUniversity: function() {
            let uri         = process.env.VUE_APP_APIHOST+'university/list';
            this.$http.get(uri,{
                params : {
                    limit    : 1000
                }
            }).then(res => {
                this.dataUniversity = res.data.data;
            });
        },
        getMajor: function() {
            let uri         = process.env.VUE_APP_APIHOST+'master-major/list';
            this.$http.get(uri).then(res => {
                this.dataMajor = res.data.data;
            });
        },
        set_university: function() {
            if (this.filter.university !== undefined && this.filter.university !== null) {
                this.university_id = this.filter.university.id;
            }  else {
                this.university_id = "";
            }
            this.getData();
        },
        set_major: function() {
            if (this.filter.major !== undefined && this.filter.major !== null) {
                this.major_id = this.filter.major.id;
            }  else {
                this.major_id = "";
            }
            this.getData();
        }
    }
}
</script>
